import ActionConstants from "../action-constants";
import { createReducer } from "../utils/redux-util";
import Reducer from "./reducer";

class CartListReducer extends Reducer {
    static getDiscountAmount(state = initialState, action) {
        return {
            ...state,
            cartListData: {
                discountAmount: action.payload
            } 
        }
    }
}

const cartListActionHandlers = {
    [ActionConstants.GET_DISCOUNT_AMOUNT]: CartListReducer.getDiscountAmount
}

const initialState = {
    cartListData: {
        discountAmount: 0
    }
}

export const cartListData = createReducer(initialState, cartListActionHandlers) 